import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ImpersonationUser } from '../models/impersonation-user.model';
import { environment } from 'src/environments/environment';

// Define the token response interface
export interface ImpersonationTokenResponse {
  refreshToken: string;
  accessToken: string;
  idToken: string;
}

@Injectable({
  providedIn: 'root',
})
export class ImpersonationService {
  private readonly apiUrl = environment.apiUrl + '/users';

  constructor(private http: HttpClient) {}

  getImpersonationUsers(): Observable<ImpersonationUser[]> {
    return this.http
      .get<{ count: number; result: ImpersonationUser[] }>(this.apiUrl)
      .pipe(map((response) => response.result));
  }

  impersonateUser(userId: string): Observable<ImpersonationTokenResponse> {
    return this.http.post<ImpersonationTokenResponse>(
      `${this.apiUrl}/${userId}/impersonate`,
      {}
    );
  }
}
